import { render, staticRenderFns } from "./Bot.vue?vue&type=template&id=46a3b33c&scoped=true"
import script from "./Bot.vue?vue&type=script&lang=js"
export * from "./Bot.vue?vue&type=script&lang=js"
import style0 from "./Bot.vue?vue&type=style&index=0&id=46a3b33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a3b33c",
  null
  
)

export default component.exports